import { render, staticRenderFns } from "./TripDetailsSection.vue?vue&type=template&id=490dba2a"
import script from "./TripDetailsSection.vue?vue&type=script&lang=ts"
export * from "./TripDetailsSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports